export default __webpack_public_path__ + "b29fa0bdcb819048e4b1bab72497c7ae.svg";